<div class="search-panel">
  <app-input
    fieldName="searchKey"
    [inputGroup]="searchForm"
    placeholder="Search User"
    [buttonIcon]="form.searchKey.value ? 'close' : 'search'"
    (buttonClick)="resetSearch()"
  ></app-input>
</div>

<ng-container *ngIf="userList | async as users">
  <ng-container  *ngIf="users.length; else emptyState">
    <div class="chat-item_block" *ngFor="let user of users">
      <div class="chat-item">
        <app-user-avatar [size]="48" [user]="user"></app-user-avatar>
        <div class="chat-item_info">
          <span class="title" (click)="openUrl('/user-profile/user/' + user.id)">{{ user?.userName || '...' }}</span>
          <span class="p6 grey-text">{{ user.firstName }} {{ user.lastName }}</span>
        </div> 
      </div>

      <div class="chat-item_actions">
        <div *ngIf="user.isOnline" class="user-online_point"></div>
        <app-button 
          icon="message-new"
          (click)="openUrl('/messenger/' + getUniqueName(user.userId))"
        ></app-button>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #emptyState>
  <span class="p1 placeholder">{{form.searchKey.value ? 'No Users Found' : 'No Members Online'}}</span>
</ng-template>

<ng-template #loadingTpl>
  <app-spinner></app-spinner>
</ng-template>